import { makeAutoObservable } from 'mobx'
import { me } from 'store/me'
import { opt } from 'store/opt'
import { BodyIndex, Gender, ShapeType } from 'type/Identity'
import { Photo } from 'type/Options'

type BasicStep = 'type' | 'first' | 'fullbody' | 'second' | 'third' | 'fourth' | 'upload'

// Выбор типа профиля показываем, только когда в виджете включены оба типа фото,
// иначе сразу открываем флоу единственного доступного типа.
export function getBasicFirstStep(): BasicStep {
  if (opt.photo.length > 1) return 'type'
  return opt.photo[0] === 'full' ? 'fullbody' : 'first'
}

// Для уже созданного профиля тип фото известен — открываем сразу нужный шаг,
// спрашивать тип заново не нужно.
export function getBasicStepForType(type: Photo): BasicStep {
  return type === 'full' ? 'fullbody' : 'first'
}

export const HEIGHT_MIN = 140
export const HEIGHT_DEF = 180
export const HEIGHT_MAX = 210
export const WEIGHT_MIN = 40
export const WEIGHT_DEF = 75
export const WEIGHT_MAX = 150

export class BasicForm {
  private _step: BasicStep = getBasicFirstStep()
  private _gender: Gender | undefined
  private _shape: ShapeType | undefined
  private _body: BodyIndex | undefined
  private _height: number = HEIGHT_DEF
  private _weight: number = WEIGHT_DEF
  private _done: boolean = false

  constructor() {
    makeAutoObservable(this)
    this.applyMetrics()
  }

  get step(): BasicStep {
    return this._step
  }

  set step(value: BasicStep) {
    this._step = value
  }

  get gender(): Gender | undefined {
    return this._gender
  }

  set gender(value: Gender | undefined) {
    this._gender = value
  }

  get shape(): ShapeType | undefined {
    return this._shape
  }

  set shape(value: ShapeType | undefined) {
    this._shape = value
  }

  get body(): BodyIndex | undefined {
    return this._body
  }

  set body(value: BodyIndex | undefined) {
    this._body = value
  }

  get height(): number {
    return this._height
  }

  set height(value: number) {
    this._height = value
  }

  get weight(): number {
    return this._weight
  }

  set weight(value: number) {
    this._weight = value
  }

  // Флоу пройден целиком. Одного identity_id мало: при загрузке фото по QR профиль
  // создаётся на телефоне, и панель получает identity, хотя юзер прошёл только первый шаг.
  get done(): boolean {
    return this._done
  }

  set done(value: boolean) {
    this._done = value
  }

  applyMetrics() {
    const { gender, body_index, shape_type, height, weight } = me.metrics
    if (gender != null) this.gender = gender
    if (shape_type != null) this.shape = shape_type
    if (body_index != null) this.body = body_index
    if (height != null) this.height = height
    if (weight != null) this.weight = weight
  }
}
